import { addRouteNamespace } from '@Utils/actions';
import { Link } from '@mui/material';
import { useHistory } from 'react-router-dom';
import React from 'react';

interface AssetIdCellProps {
	assetId: string;
}

export const AssetIdCell = ({ assetId }: AssetIdCellProps) => {
	const history = useHistory();
	return (
		<Link
			underline="hover"
			style={{
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				cursor: 'pointer',
			}}
			title={assetId}
			onClick={() => {
				history.push(
					addRouteNamespace(
						`riskAssetDetails/${encodeURIComponent(assetId)}`,
					),
				);
			}}>
			{assetId}
		</Link>
	);
};
